import script from "./LoginOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginOverlay.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__